var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Autocomplete',{attrs:{"suggestions":_vm.suggestions,"disabled":_vm.pin === null},on:{"selected":_vm.addToList}}),_vm._v(" "),_c('div',{staticClass:"invitee-list-container"},[_c('InviteeList',{attrs:{"invitees":_vm.invitees,"editable":true},on:{"removed":_vm.handleRemoved}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85e31e60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking/Invites/index.vue
// module id = null
// module chunks = 